import { shallowEqual, useSelector } from 'react-redux'

import { makeUpdateFilter } from 'actions/ui/shared/filter'
import { useAction } from 'hooks/redux/useAction'
import { PageId } from 'routing/pages'
import {
    selectCurrencyCode,
    selectFilters,
    selectIsPageContentDisabled,
    selectLabelsForFilters,
    selectLabelsOrdered,
} from 'selectors/ui'
import { selectCustomEventsForWidget } from 'selectors/ui/customEvents'
import {
    AppFiltersState,
    BooleanFilterOption,
    CurrencyCode,
    CustomEvent,
    Label,
    PageFilters,
    RootReduxState,
} from 'types'

interface AppStateObject {
    currencyCode: CurrencyCode
    isPageContentDisabled: boolean
    organizationLabels: Label[]
    labelsForFilters: BooleanFilterOption[]
}

const appKey: Extract<PageId, 'app'> = 'app'

const DEFAULT_EMPTY: [] = []

export const useAppState = (): AppStateObject => ({
    currencyCode: useSelector(
        (state: RootReduxState) => selectCurrencyCode(state),
        shallowEqual
    ),
    isPageContentDisabled: useSelector(
        (state: RootReduxState) => selectIsPageContentDisabled(state),
        shallowEqual
    ),
    organizationLabels: useSelector(
        (state: RootReduxState) => selectLabelsOrdered(state),
        shallowEqual
    ),
    labelsForFilters:
        useSelector(
            (state: RootReduxState) => selectLabelsForFilters(state),
            shallowEqual
        ) ?? DEFAULT_EMPTY,
})

export function useAppFilters(): AppFiltersState {
    return useSelector<RootReduxState, AppFiltersState>(
        (state) => selectFilters<AppFiltersState>(state, [appKey]),
        shallowEqual
    )
}

const updateFilter = makeUpdateFilter([appKey])

export function useAppUpdateFilter(): any {
    return useAction(updateFilter)
}

export const useCustomEventsForWidget = (filters: PageFilters): CustomEvent[] =>
    useSelector<RootReduxState, CustomEvent[]>((state) =>
        selectCustomEventsForWidget(state, filters)
    )
